import React from 'react';
import TeamHero from '../components/TeamHero';
import TeamGrid from '../components/TeamGrid';

function TeamPage() {
  return (
    <div className="page">
      <TeamHero />
      <TeamGrid />
    </div>
  );
}

export default TeamPage;
